import { FC } from 'react'
import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { Image } from '@/atoms/Image'
import { AsH2, Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  onClose: () => void
}

const CloseButton: FC<{ onClose: () => void }> = ({ onClose }) => (
  <button
    onClick={onClose}
    className="absolute right-4 top-4 rounded-full bg-gray-300 p-2 transition-colors duration-200 hover:bg-gray-400"
    aria-label="Close"
  >
    <svg
      className="h-4 w-4 text-gray-900"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
)

export const AutobookConfirmationStep: FC<Props> = ({ onClose }) => {
  const { t } = useTranslate('account')

  return (
    <div className="flex h-full flex-col items-center justify-between p-4 text-start md:p-12">
      <CloseButton onClose={onClose} />

      <div className="flex flex-col items-center">
        <Image
          className="mb-8 w-full max-w-[215px] md:max-w-[280px]"
          src="v1742574227/angel-web/seat-confirmation-illustration"
          alt={t('saveMySeatConfirmation', 'Save My Seat confirmation illustration')}
          width={280}
          height={173}
        />

        <Text
          as={AsH2}
          className={classNames('mb-6 text-start', 'md:photon-heading-sm', 'photon-title-lg')}
          weight="bold"
        >
          {t('youreOnTheVIPList', "You're on the VIP List! Save My Seat Enrollment Confirmed.")}
        </Text>

        <Text className={classNames('mb-8 leading-[26px]', 'photon-body-sm md:photon-body-lg')} color="gray-700">
          {t(
            'youveSuccessfullyEnrolledInSaveMySeat',
            "You've successfully enrolled in Save My Seat! Once this feature goes live, you'll be the first to get text notifications about showtimes at your favorite theaters, on your preferred days and times.",
          )}
        </Text>

        <Text className={classNames('mb-8 leading-[26px]', 'photon-body-sm md:photon-body-lg')} color="gray-700">
          {t(
            'stayTunedWeWillTextYou',
            "Stay tuned! We'll text you as soon as it's ready. Thanks for being a part of something amazing.",
          )}
        </Text>
      </div>
      <div className="w-full shrink-0 py-6">
        <Button onClick={onClose} variant="black" className="w-full">
          {t('close', 'Close')}
        </Button>
      </div>
    </div>
  )
}
